module.exports = __webpack_public_path__ + "static/media/5.54faff3a.png";